<div class="alert-label pink-alert zk-w-full zk-flex zk-gap-3">
	<div class="zk-w-3 zk-flex info-icon">
		<span class="freud-icon-info-circle freud-icon freud-icon-xs"></span>
	</div>
	<div class="zk-w-11/12">
		<div class="zk-mb-4">
			<p
				class="text-info"
				[innerHTML]="
					'MY_ACCOUNT.FINANCIAL.BANK_DATA.BANK_VALIDATION' | translate
				"
			></p>
		</div>
	</div>
</div>
